import { render, staticRenderFns } from "./MapWave.vue?vue&type=template&id=70a93ec0&scoped=true&"
import script from "./MapWave.vue?vue&type=script&lang=ts&"
export * from "./MapWave.vue?vue&type=script&lang=ts&"
import style0 from "./MapWave.vue?vue&type=style&index=0&id=70a93ec0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a93ec0",
  null
  
)

export default component.exports